function handleCollectionNav(e) {
  e.preventDefault();
  const menu = document.querySelector('.mobile-collection-link-container');
  
  if(menu.classList.contains('active')){
    menu.classList.remove('active');
  }else {
    menu.classList.add('active');
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const activeLink = document.querySelector('.mobile-collection-link-active');

  activeLink.addEventListener('click', handleCollectionNav);
});